import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../App.css";
import "./TestimonialContent.css";
import TestimonialTabs from "./TestimonialTabs";
import { useMsal } from "@azure/msal-react";

function TestimonialContent() {
  const [click, setClick] = useState(false);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const AdminUsers = [
    "rashi.shrivastava",
    "reshmi.haridas.m",
    "d.d.choudhary",
    "h.srinivasan",
    "varsha.a.tyagi",
    "jeevadharani.ramanan",
    "akash.e.tyagi",
    "lavanya.umesh",
    "aluru.akash",
    "shramika.s.ambolkar",
    "lakshay.c.gupta",
    "aayushi.bharti",
    "uma.rani.battu",
    "akash.e.tyagi",
    "j.b.mittal",
    "b.prasad.mishra",
    "arpita.m.singh"
  ];
  return (
    <div className="main-container techexpressway-container">
      <title>Tech Expressway - Testimonials</title>
      <h1 className="sr-only" tabIndex={0}>
        Voices of Delight
      </h1>
      <p className="sr-only">Real Stories, Real Smiles</p>
      <img
        src="/images/testimonial/new-banner.png"
        alt="testimonial-banner-image"
        className="banner-img"
      />
      <nav className="navbar">
        <div className="navbar-container">
          <ul className="nav-menu">
            <li className="nav-item">
              <NavLink
                to="/home"
                className="nav-links"
                activeClassName="is-active"
                exact={true}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/foundation-component"
                target="_blank"
                className="nav-links"
                activeClassName="is-active"
              >
                Foundation
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/job-readiness"
                target="_blank"
                className="nav-links"
                activeClassName="is-active"
              >
                Job Readiness
              </NavLink>
            </li>
            <li className="nav-item">
              <a
                href="https://atci.techleap.accenture.com"
                className="nav-links"
                target="_blank"
              >
                Specialization
              </a>
            </li>
            {/* <li className="nav-item">
                            <NavLink to="/gamification" className="nav-links" activeClassName="is-active" exact={true}>Gamification</NavLink>
                        </li> */}
            <li className="nav-item">
              <NavLink
                to="/techexpressway-faq"
                className="nav-links"
                activeClassName="is-active"
                exact={true}
              >
                FAQs
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/Testimonials"
                className="nav-links"
                activeClassName="is-active"
                exact={true}
              >
                Testimonials
              </NavLink>
            </li>
            {AdminUsers.includes(loggedInEnterpriseId) && (
              <li className="nav-item">
                <NavLink
                  to="/analytics"
                  className="nav-links"
                  activeClassName="is-active"
                  exact={true}
                >
                  Analytics
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </nav>
      <div className="testimonial-container" id="main">
        <div className="testimonial-wrap">
          <h2>
            Inspiring Testimonials from <span>Learners and Leaders</span>{" "}
          </h2>
          <img
            src="images/testimonial/top-quote.png"
            alt="quote mark"
            className="top-quote"
          />
          <TestimonialTabs />
          <img
            src="images/testimonial/bottom-quote.png"
            alt="quote mark"
            className="bottom-quote"
          />
        </div>
      </div>
    </div>
  );
}

export default TestimonialContent;
